/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { Grid, Typography } from '@rentacenter/racstrap';
import { Document, Page, pdfjs } from 'react-pdf';
import { useTranslation } from 'react-i18next';
import { convertImageToPDF, convertPDFToBase64 } from './helperFunction/HelperFunction';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const FileToPDFViewer = ({ file }: any) => {
  const { t } = useTranslation();
  const [pdfBlobUrl, setPdfBlobUrl] = useState<string>('');
  const [numPages, setNumPages] = useState<number>(0);
  const [containerWidth, setContainerWidth] = useState<number>(600);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleFile = async () => {
    try {
      const fileType = file?.type;
      let blobUrl: string | null = null;

      if (fileType === 'application/pdf') {
        const pdfData: any = await convertPDFToBase64(file);
        blobUrl = pdfData?.url;
      } else if (fileType && fileType.startsWith('image/')) {
        const reader = new FileReader();
        reader.onloadend = async () => {
          const imageB64String = await convertImageToPDF(reader.result);
          const base64Pdf: any = await convertPDFToBase64(imageB64String);
          setPdfBlobUrl(base64Pdf?.url);
        };
        reader.readAsDataURL(file);
        return;
      } else if (!fileType && file?.startsWith('data:image/')) {
        const imageB64String = await convertImageToPDF(file.split(',')[1]);
        const base64Pdf: any = await convertPDFToBase64(imageB64String);
        blobUrl = base64Pdf?.url;
      }

      if (blobUrl) {
        setPdfBlobUrl(blobUrl);
      }
    } catch (error) {
      console.error('Error processing file:', error);
    }
  };

  useEffect(() => {
    if (file) handleFile();
  }, [file]);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth);
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <Grid ref={containerRef} style={{ width: '100%', overflow: 'hidden' }}>
      {pdfBlobUrl ? (
        <Document
          file={pdfBlobUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          loading={<Typography>{t('Loading')}...</Typography>}
          error={<Typography color="error">{t('Failed to load PDF file.')}</Typography>}
        >
          {Array.from(new Array(numPages), (_, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={containerWidth} />
          ))}
        </Document>
      ) : (
        <Typography>{t('Loading')}...</Typography>
      )}
    </Grid>
  );
};

export default FileToPDFViewer;
